module.exports = __webpack_public_path__ + "img/training_program_1.e8f59283.jpg";